// apps/web/src/components/ui/Card.tsx
// The one surface-card container. Optional title renders a SectionHeader.
import type { ReactNode } from "react";
import { SectionHeader } from "./SectionHeader";

export function Card({
  title, action, glass = false, className = "", children,
}: { title?: ReactNode; action?: ReactNode; glass?: boolean; className?: string; children: ReactNode }) {
  // `glass` swaps the solid surface for the Liquid-Glass material — use it only
  // for cards that float directly over the wallpaper (e.g. the Stats page), not
  // for Cards rendered inside a sheet (which is itself glass).
  return (
    <section className={`${glass ? "glass" : "bg-surface"} rounded-2xl p-4 space-y-3 ${className}`}>
      {title != null && <SectionHeader action={action}>{title}</SectionHeader>}
      {children}
    </section>
  );
}
